import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">观影体验</h2>
          <p className="mt-2 text-sm text-foreground-500">用心打造每一个观影细节</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg p-5 md:p-6 text-center transition-all duration-300 hover:-translate-y-1 cursor-default"
            >
              <div className="w-12 h-12 mx-auto rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}